import { Spin } from 'antd';
import { useLazyGetFaqQuery } from 'app/services/edpApiV1/faq';
import { useAppDispatch, useAppSelector } from 'app/store';
import { categoryActions } from 'entities/faq/model/category';
import { viewerModel } from 'entities/viewer';
import FaqTable from 'features/tables/faqTable';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SortCondition } from 'shared/enums';
import { FaqStatuses, SearchKeysFaq } from 'shared/enums/FAQ';
import { dataForFaqTable, sortingDate } from 'shared/helpers/utils';
import { usePullSort } from 'shared/hooks';
import { TFaqColumns, TFaqGetResponsePaginated, TSearchDataFaq } from 'shared/types/faq.types';

const FaqUnpublicated = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [sortInfo, trigger] = usePullSort();
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const { search } = useAppSelector(state => state.entities.search);
  const [getFaqQueryRequest, result] = useLazyGetFaqQuery();
  const dispatch = useAppDispatch();
  const [searchData, setSearchData] = useState<TSearchDataFaq>({ key: SearchKeysFaq.SEARCH_NAME, value: '' });

  useEffect(() => {
    dispatch(categoryActions.setIsCategoryTab(false));
  }, []);

  useEffect(() => {
    getFaqQueryRequest({
      size: currentSize,
      page: currentPage,
      type: FaqStatuses.UNPUBLICATED,
      [searchData.key]: searchData.value ? searchData.value : undefined,
    });
  }, [currentPage, currentSize, getFaqQueryRequest]);

  const onSearch = (data: string | null, key: SearchKeysFaq) => {
    setSearchData({ key, value: data || '' });
    if (data !== null) {
      getFaqQueryRequest({
        size: currentSize,
        page: currentPage,
        type: FaqStatuses.UNPUBLICATED,
        [key]: data ? data : undefined,
      });
    } else {
      getFaqQueryRequest({
        size: currentSize,
        page: currentPage,
        type: FaqStatuses.UNPUBLICATED,
      });
    }
  };

  const columns: TFaqColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Действие',
      key: 'action',
      render: (text, record) => {
        return <Link to={`/faq/update/${record.id}`}>Редактировать</Link>;
      },
    },
    {
      title: 'Автор',
      dataIndex: 'fio',
      key: 'fio',
    },
    {
      title: 'Категория',
      dataIndex: 'category',
      key: 'category',
    },
  ];
  return (
    <Spin spinning={result.isFetching || result.isLoading}>
      {result.data ? (
        <FaqTable
          dataSource={dataForFaqTable(result?.data.data || [])}
          columns={columns}
          currentPage={currentPage}
          currentSize={currentSize}
          setCurrentPage={setCurrentPage}
          setCurrentSize={setCurrentSize}
          total={result?.data.pagination.total}
          onSearch={onSearch}
        />
      ) : null}
    </Spin>
  );
};

export default FaqUnpublicated;
